import "./styles/App.css";
import "animate.css";
/* ── Split stylesheets (previously all in Home.css) ── */
import "./styles/Home.css";
import "./styles/About.css";
import "./styles/WhyChooseUs.css";
import "./styles/Products.css";
import "./styles/ProjectsPage.css";
import "./styles/QualityControl.css";
import "./styles/ContactFaq.css";
import "./styles/Sponsors.css";
import "./styles/Shared.css";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.min.js";
import i18n from "./locales/i18n";
import "./styles/rtl.css";
import "./styles/Media.css";
import { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home/Home";
import About from "./pages/About/About";
import WhoWeAre from "./pages/About/WhoWeAre";
import Mission from "./pages/About/Mission";
import Vision from "./pages/About/Vision";
import Values from "./pages/About/Values";
import Products from "./pages/Products/Products";
import Rebar from "./pages/Products/Rebar";
import Bellet from "./pages/Products/Billet";
import Catalogue from "./pages/Products/Catalogue";
import QualityControl from "./pages/Quality/QualityControl";
import Certifications from "./pages/Quality/Certifications";
import MegaProjects from "./pages/Projects/MegaProjects";
import HousingProjects from "./pages/Projects/HousingProjects";
import Accreditation from "./pages/Projects/Accreditation";
import Projects from "./pages/Projects/Projects";
import FindUs from "./pages/Contact/ContactUs";
import Faqs from "./pages/Faqs/Faqs";

function App() {
  const [isRTL, setIsRTL] = useState(false);

  useEffect(() => {
    const updateLanguage = () => {
      const lang = i18n.language;
      setIsRTL(lang === "ar");
    };

    updateLanguage();

    i18n.on("languageChanged", updateLanguage);

    return () => {
      i18n.off("languageChanged", updateLanguage);
    };
  }, []);

  return (
    <div dir={isRTL ? "rtl" : "ltr"}>
      <div className="container-fluid">
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/who-we-are" element={<WhoWeAre />} />
            <Route path="/mission" element={<Mission />} />
            <Route path="/vision" element={<Vision />} />
            <Route path="/values" element={<Values />} />
            <Route path="/products" element={<Products />} />
            <Route path="/steel-products/rebar" element={<Rebar />} />
            <Route path="/steel-products/billet" element={<Bellet />} />
            <Route path="/catalogue" element={<Catalogue />} />
            <Route path="/quality-control" element={<QualityControl />} />
            <Route path="/certifications" element={<Certifications />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/projects/mega-projects" element={<MegaProjects />} />
            <Route path="/housing-projects" element={<HousingProjects />} />
            <Route path="/accreditation" element={<Accreditation />} />
            <Route path="/faqs" element={<Faqs />} />
            <Route path="/contact-us" element={<FindUs />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </Router>
      </div>
    </div>
  );
}

export default App;
